const setTimeout = () => window.localStorage.setItem("timeout", JSON.stringify(Math.floor(Date.now() / 1000)));
const getTimeout = () => parseInt((window.localStorage.getItem("timeout") as string) ?? null);

export { setTimeout, getTimeout };
